import { useI18n } from "~/composables/useI18n";
import { createLangImgMapFromGlob, getLangImg as resolveLangImg } from "~/utils/i18n-locale-images";

/**
 * 获取多语言图片路径（响应式，随语言切换自动更新）
 *
 * 目录约定：相对路径/zh-tw|en/文件名
 *
 * @param {Record<string, string>} globModules - 组件内 import.meta.glob 的结果
 * @returns {(fileName: string, fallbackDir?: string) => string}   -第一个参数：文件名，第二个参数：默认语言（兜底）
 *
 * 用法：在组件内先 useLangImg(import.meta.glob(...))，模板中 getLangImg('load.png')
 */
export function useLangImg(globModules) {
	const { locale, trackTranslationDeps } = useI18n();
	const imageMap = createLangImgMapFromGlob(globModules);

	return (fileName, fallbackDir) => {
		trackTranslationDeps();
		return resolveLangImg(imageMap, fileName, locale.value, fallbackDir);
	};
}
